import cookies from 'js-cookie';

const isAuthenticated = () =>
  cookies.get('authToken')?.length > 0 || cookies.get('.AspNetCore.Cookies')?.length > 0;

export { isAuthenticated };
